'use client';

import { createContext, useContext } from 'react';
import { defaultLocale, Locale } from './locale';

const LocaleContext = createContext(defaultLocale);

export function LocaleContextProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

export function useCurrentLocale() {
  return useContext(LocaleContext);
}
